import { trackEvent } from '../../../modules/analytics';

export const clickedFooterLink = link => {
  trackEvent(
    null,
    {
      eventCategory: 'Footer',
      eventAction: 'Click',
      eventLabel: `${link} Link`,
    },
    { providers: [ga] }
  );
};
